const cachePrefix = 'cache:'

function cacheKey(key) {
  return `${cachePrefix}${key}`
}

/**
 * Remove all items from the cache.
 */
function bust() {
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith(cachePrefix)) {
      localStorage.removeItem(key)
    }
  })
}

function get(key) {
  // Caching is disabled in development to prevent
  // forgetting to load data in second-level components.
  // For example, an individual chart might depend on a
  // parent component to load its data--on its own it won't
  // load at all.
  if (process.env.NODE_ENV === 'development') {
    // return undefined
  }
  if (localStorage.getItem(cacheKey(key))) {
    const cache = JSON.parse(localStorage.getItem(cacheKey(key)))
    // eslint-disable-next-line no-undef
    if (cache.version !== COMMITHASH) {
      localStorage.removeItem(cacheKey(key))
      return undefined
    }
    return cache.data
  }
  return undefined
}

function remove(key) {
  localStorage.removeItem(cacheKey(key))
}

function set(key, value) {
  try {
    localStorage.setItem(cacheKey(key), JSON.stringify({
      data: value,
      // eslint-disable-next-line no-undef
      version: COMMITHASH,
    }))
  } catch (e) {
    // QuotaExceededError
    if (e.code === 22 || e.name === 'QuotaExceededError') {
      // eslint-disable-next-line no-console
      console.log(`LocalStorage quota exceeded for key ${key}`)
    } else {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }
}

export default {
  get,
  remove,
  set,
  bust,
}



// WEBPACK FOOTER //
// ./src/store/helpers/cache.helper.js